import React, { FC } from "react";
import { Icon } from "@shared/components";
import { Button } from "rsuite";

import "./index.scss";

interface StationViewRawDataHeaderProps {
  isCloseLoading: boolean;
  isCloseDisabled: boolean;
  onClose: () => void;
}

const StationViewRawDataHeader: FC<StationViewRawDataHeaderProps> = ({ onClose, isCloseLoading, isCloseDisabled }) => {
  return (
    <div className="station-view-raw-data-header">
      <Button className="close-btn" disabled={isCloseDisabled} loading={isCloseLoading} onClick={() => onClose()}>
        <Icon type="clear" />
      </Button>
    </div>
  );
};

export default StationViewRawDataHeader;
